import React from 'react';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.sections}>

          {/* 1) Newsletter */}
          <div className={styles.newsletter}>
            <h3>Subscribe to our Newsletter</h3>
            <form className={styles.form} onSubmit={e => e.preventDefault()}>
              <input
                type="email"
                placeholder="Your email address"
                aria-label="Email for newsletter"
                required
              />
              <button type="submit">Subscribe</button>
            </form>
          </div>

          {/* 2) Contact TWIG */}
          <div className={styles.contact}>
            <h3>Contact TWIG</h3>
            
            <p>
              Email:{' '}
              <a href="mailto:twiguzbekistan@gmail.com" target="_blank" rel="noopener noreferrer">
                twiguzbekistan@gmail.com
              </a>
            </p>
            
          </div>

          {/* 3) Connect with us */}
          <div className={styles.connect}>
            <h3>Connect with us</h3>
            <ul className={styles.social}>
              <li>
                <a
                  href="https://www.facebook.com/share/g/1GnXs4qYoU/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/twig.uzbekistan"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li>
              {/* <li>
                <a
                  href="https://www.linkedin.com/company/TWIGUzbekistan"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li> */}
            </ul>
          </div>

        </div>

        {/* Developer info in the corner */}
        <div className={styles.developerContainer}>
          <p className={styles.developer}>
            Website developed by <a href="mailto:info@orionect.com" target="_blank" rel="noopener noreferrer">Orionect Technologies</a>
          </p>
        </div>

        <div className={styles.copy}>
          © {new Date().getFullYear()} TWIG. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
